import React, { Component, ErrorInfo, ReactNode } from 'react';
import ParseHtml from '../ParseHtml';
import './ErrorCustom.scss';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      //@ts-ignore
      // eslint-disable-next-line no-useless-escape
      const copy = JSON.parse(sessionStorage.getItem('persist:root').toString().replace(/[/\*]/g, '')).siteContent;
      const siteContent = JSON.parse(copy);

      return (
        <React.Fragment>
          <div className="container customError">
            <div>
              <ParseHtml
                htmlInput={siteContent.resources.messages[
                  'preview-sales-engine.static-content.copy.Labels.generic-error-message'
                ]
                  .replace('<p>You will be redirected to homepage in<p><p class="timerStyle">%s<p><p> seconds<p>', '')
                  .replace('<a href="">', '<a href="/">')
                  .replace('<a>', '</a>')}
              />
            </div>
          </div>
        </React.Fragment>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
